import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';

import _ from 'lodash';
const ReactMarkdown = require('react-markdown');

const FaqAccordian = ({ faq }) => {
  return (
    <Accordion allowZeroExpanded="true">
      {_.map(faq, (currentQandA, key) => {
        return (
          <AccordionItem key={key}>
            <AccordionItemHeading>
              <AccordionItemButton className="accordion__button themeFocus">
                <h3>{currentQandA.Question}</h3>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ReactMarkdown source={currentQandA.Answer} />
            </AccordionItemPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
export default FaqAccordian;
